import MailTemplates                                                from "../../../../domain/mail/template/MailTemplates";
import { ACTION_TYPE, MailTemplatesAction, SetMailTemplatesAction } from "./MailTemplatesAction";

const reduceMailTemplates = (action: SetMailTemplatesAction): MailTemplates => action.mailTemplates;
const mailTemplatesReducer = (state: MailTemplates = new MailTemplates(), action: MailTemplatesAction): MailTemplates => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.SET_MAIL_TEMPLATES:
      return reduceMailTemplates(action as SetMailTemplatesAction);
  }
};

export default mailTemplatesReducer;
